import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastComponent } from "../../../../../shared/components/toast/toast.component";
import { AdminTopbarComponent } from "../../../components/admin-topbar/admin-topbar.component";
import { AdminNavigationComponent } from "../../../components/admin-navigation/admin-navigation.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { ProductGet } from '../../../../../core/interfaces/sales-engine-interfaces';
import { SalesEngineService } from '../../../../../core/api/sales-engine.service';
import { CommonModule } from '@angular/common';
import { DeleteConfirmationDialogComponent } from "../../../../../shared/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CreateEditProductComponent } from "../../../components/upsell-engine/create-edit-product/create-edit-product.component";
import { SalesEngineDataService } from '../../../../../core/services/sales-engine-data.service';

@Component({
  selector: 'app-admin-products-services',
  standalone: true,
  imports: [ToastComponent, AdminTopbarComponent, AdminNavigationComponent, TranslocoPipe, CustomButtonComponent, CommonModule, DeleteConfirmationDialogComponent, CreateEditProductComponent],
  templateUrl: './admin-products-services.component.html',
  styleUrl: './admin-products-services.component.css'
})
export class AdminProductsServicesComponent implements OnInit {
  constructor(private salesEngineData: SalesEngineDataService, private salesEngine: SalesEngineService, private apiError: ApiErrorService, private cdRef: ChangeDetectorRef) { }
  @ViewChild(ToastComponent) toast?: ToastComponent;

  @ViewChild(DeleteConfirmationDialogComponent) deleteDialog!: DeleteConfirmationDialogComponent;
  @ViewChild('editCreateRef') editCreateRef!: ElementRef;

  isEditCreateOpen: boolean = false;
  isEditing: boolean = false;
  selectedProduct?: ProductGet;

  reloadProducts = () => this.salesEngineData.reloadProducts();

  get products(): ProductGet[] {
    return this.salesEngineData.getProducts();
  }

  ngOnInit(): void {
    this.cdRef.detectChanges();
  }

  createItem() {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();



    this.isEditing = false;
    this.selectedProduct = undefined;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  editItem(item: ProductGet) {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();

    this.isEditing = true;
    this.selectedProduct = item;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  async deleteItem(item: ProductGet) {
    if (!await this.deleteDialog.openModal()) {
      return;
    }

    try {
      await lastValueFrom(this.salesEngine.deleteProduct(item.id));

      this.reloadProducts();
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      return;
    }
  }
}
